import { Building, AlertCircle } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { LEGAL_CONFIG } from '@/lib/config';
import { PageLayout } from '@/components/Layout/PageLayout';

export default function Imprint() {
  const { privacyReady, controllerName, controllerEmail, controllerAddress } = LEGAL_CONFIG;

  return (
    <PageLayout title="Imprint / Contact" maxWidth="2xl">
      <div className="space-y-6">
        {!privacyReady && (
          <Alert>
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>
              <strong>Postal address: pending PostNL postbox activation.</strong><br />
              For any legal or privacy notices, contact <a href={`mailto:${controllerEmail}`} className="text-primary underline">{controllerEmail}</a>.
            </AlertDescription>
          </Alert>
        )}

        <Card className="p-6 space-y-4">
          <div className="flex items-center gap-3 mb-4">
            <Building className="w-6 h-6 text-primary" />
            <h2 className="text-xl font-semibold">Legal Information</h2>
          </div>

          <div className="space-y-4 text-base leading-relaxed text-foreground/80">
            <div className="space-y-2">
              <h3 className="font-semibold text-foreground">Data Controller</h3>
              <p>
                <strong>{controllerName}</strong><br />
                {privacyReady && controllerAddress ? (
                  controllerAddress.split('\n').map((line, i) => (
                    <span key={i}>{line}<br /></span>
                  ))
                ) : (
                  <span className="text-muted-foreground italic">
                    Address pending - see notice above
                  </span>
                )}
              </p>
            </div>

            <div className="space-y-2">
              <h3 className="font-semibold text-foreground">Contact</h3>
              <p>
                Email: <a href={`mailto:${controllerEmail}`} className="text-primary underline">
                  {controllerEmail}
                </a>
              </p>
            </div>

            <div className="space-y-2">
              <h3 className="font-semibold text-foreground">Data Protection Officer</h3>
              <p>
                For privacy-related inquiries, please contact us at the email above.
              </p>
            </div>

            <div className="space-y-2">
              <h3 className="font-semibold text-foreground">Supervisory Authority</h3>
              <p>
                <strong>Autoriteit Persoonsgegevens (Dutch DPA)</strong><br />
                Postbus 93374<br />
                2509 AJ Den Haag<br />
                Netherlands<br />
                Website: <a 
                  href="https://autoriteitpersoonsgegevens.nl" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary underline"
                >
                  autoriteitpersoonsgegevens.nl
                </a>
              </p>
            </div>
          </div>
        </Card>
      </div>
    </PageLayout>
  );
}
